export const globalDomains = {
  "EMUDHRA": [
    "https://authenticate.sandbox.emudhra.com/AadhaareSign.jsp?txnref=",
    "https://demosignergateway.emsigner.com/eMsecure/V3_0/Index",
    "https://authenticate.sandbox.emudhra.com/AadhaareSign.jsp?txnref=",
    "https://demosignergateway.emsigner.com/eMsecure/V3_0/Index",
    "https://authenticate.e-mudhra.com/AadhaareSign.jsp?txnref=",
    "https://emgateway.emsigner.com/eMsecure/V3_0/Index",
    "https://demogateway-core.emsigner.com/Secure/index",
    "https://gateway-core.emsigner.com/Secure/index",
    "https://stress-credit-line-kyc-sdk-web.blackbuck.com/esign/redirect",
    "https://credit-line-kyc-sdk-web.blackbuck.com/esign/redirect"
  ],
  "ABCL": [
    "https://aaq4824.id.cyberark.cloud",
    "https://abcsso.insideabc.com"
  ],
  "DOQFY": [
    "https://dev.doqfy.in",
    "https://uat.doqfy.in",
    "https://prod.doqfy.in"
  ]
};